export default __webpack_public_path__ + "static/media/Mustafa's Résumé.c6955316.pdf";